import { storage } from "./clStorage";

// Records that the user manually confirmed a peer's Cipher Lock safety number.
// Keyed to the exact safety number so verification auto-resets if keys ever change.
const key = (userId, chatId) => `bloq_cl_verified_${userId}_${chatId}`;

export async function getVerified(userId, chatId, safetyNumber) {
  if (!userId || !chatId || !safetyNumber) return false;
  const v = await storage.secureGet(key(userId, chatId), null);
  return v === safetyNumber;
}

export async function setVerified(userId, chatId, safetyNumber) {
  await storage.secureSet(key(userId, chatId), safetyNumber || "");
}

// ── Group Cipher Lock (Circles) per-member verification — Phase 2b ──────────
// A group has N members, not one peer, so there is no single mutual safety number. Each member's
// verification is tracked individually and web-locally, keyed to that member's identity fingerprint
// so it auto-resets if their keys ever change. (No cross-platform safety-number derivation.)
const gkey = (userId, bloqId, memberId) => `bloq_cl_gverified_${userId}_${bloqId}_${memberId}`;

export async function getMemberVerified(userId, bloqId, memberId, fp) {
  if (!userId || !bloqId || !memberId || !fp) return false;
  const v = await storage.secureGet(gkey(userId, bloqId, memberId), null);
  return v === fp;
}

export async function setMemberVerified(userId, bloqId, memberId, fp) {
  await storage.secureSet(gkey(userId, bloqId, memberId), fp || "");
}

// Whole-Circle confirmation of the shared group safety code (drives the "Verified secure" header pill).
// Keyed to the current safety number so it auto-resets whenever membership/identity changes the code.
const gckey = (userId, bloqId) => `bloq_cl_gcode_${userId}_${bloqId}`;

export async function getGroupCodeVerified(userId, bloqId, safetyNumber) {
  if (!userId || !bloqId || !safetyNumber) return false;
  const v = await storage.secureGet(gckey(userId, bloqId), null);
  return v === safetyNumber;
}

// Richer state for the header pill: verified (stored == current code) vs stale (a DIFFERENT code was
// confirmed before → the group rotated). stale drives the amber "re-verify" hint.
export async function getGroupCodeState(userId, bloqId, safetyNumber) {
  if (!userId || !bloqId || !safetyNumber) return { verified: false, stale: false };
  const stored = await storage.secureGet(gckey(userId, bloqId), null);
  return { verified: stored === safetyNumber, stale: !!stored && stored !== safetyNumber };
}

export async function setGroupCodeVerified(userId, bloqId, safetyNumber) {
  await storage.secureSet(gckey(userId, bloqId), safetyNumber || "");
}
